import {
  EServiceType,
  ICheckPublishTermSchema,
} from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { IServicePeriod } from '../../../../reducers';

interface IMapCalltrackingTermParams {
  period: IServicePeriod;
}

export function mapCalltrackingTerm(params: IMapCalltrackingTermParams): ICheckPublishTermSchema {
  const { period } = params;
  const { type, days, tariffIdentificator, token } = period;

  return {
    type,
    days,
    services: [EServiceType.calltracking],
    tariffIdentificator,
    token,
  };
}
